/* HR26 stage C: sold-out sticky CTA -> alternatives */
(function () {
  var d = document;
  function soldoutSticky() {
    var host = d.querySelector('sticky-add-to-cart');
    var alts = d.getElementById('hr-alts');
    if (!host || !alts) return;
    var btn = host.querySelector('.sticky-add-to-cart__button');
    if (!btn || btn.__hr) return;
    function apply() {
      var avail = host.getAttribute('data-variant-available') === 'true';
      if (avail) { btn.classList.remove('hr-alt-cta'); return; }
      btn.disabled = false; btn.classList.add('hr-alt-cta');
      var c = btn.querySelector('.add-to-cart-text__content span') || btn.querySelector('.add-to-cart-text__content');
      if (c) c.textContent = 'Alternativen';
    }
    btn.__hr = 1;
    btn.addEventListener('click', function (e) {
      if (!btn.classList.contains('hr-alt-cta')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      alts.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
    apply();
    new MutationObserver(apply).observe(host, { attributes: true, attributeFilter: ['data-variant-available'] });
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#hr-alts"]');
    if (!a) return; var t = d.getElementById('hr-alts'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', soldoutSticky); else soldoutSticky();
})();

/* HR26 404: if the in-stock rails came out empty in the 404 render context, load them from a 200 context. */
(function () {
  var box = document.querySelector('[data-hr404-rails]');
  if (!box || box.querySelector('.hr-minirail')) return;
  fetch('/?section_id=hr26-404', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.text() : ''; })
    .then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('[data-hr404-rails]');
      if (src && src.querySelector('.hr-minirail')) box.innerHTML = src.innerHTML;
    })
    .catch(function () {});
})();
